export const MY_PRODUCTION_HISTORY = '/my_production_history/';
export const PRODUCTION_HISTORY_BY_ID = id =>
  `/my_production_history/${id}/manage`;
